import { UseFormRegisterReturn } from 'react-hook-form';
import { InterestRadioButton } from './interest-radio-button';
import { Typography } from '@/components';
import { Input } from '@/components/ui/input';
import { t } from 'i18next';
import { TechnologyType } from '@/features/projects/types';
import { ChangeEvent } from 'react';

interface TechnologiesSectionProps {
  technologies: { label: string; value: TechnologyType; icon: string }[];
  registration?: Partial<UseFormRegisterReturn>;
  selectedTechnologies: string[];
  otherValue: string;
  onOtherChange: (value: string) => void;
  isCompanyForm?: boolean;
}

export function TechnologiesSection({
  technologies,
  registration,
  selectedTechnologies,
  otherValue,
  onOtherChange,
  isCompanyForm,
}: TechnologiesSectionProps) {
  const OTHER_TECH_MAX = 50;
  const otherText = Array.isArray(otherValue) ? otherValue.join(', ') : (otherValue ?? '');
  const otherLength = otherText.length;
  return (
    <div className="space-y-2">
      {isCompanyForm ? (
        <div className="space-y-0.5">
          <Typography as="h4" color="primary" size="body-1" weight="semibold">
            {t('Technology')}
          </Typography>
        </div>
      ) : (
        <div className="space-y-0.5">
          <Typography as="h4" color="primary" size="title" weight="semibold">
            {t('What technologies interest you the most?')}
          </Typography>
          <Typography as="p" size="body-3" color="secondary" weight="normal" className="mt-1">
            {t('You can select more than one option')}
          </Typography>
        </div>
      )}
      <div className="flex flex-wrap justify-left gap-2 md:justify-start">
        {technologies.map(({ label, value, icon }) => (
          <InterestRadioButton
            key={value}
            id={`technology-${value}`}
            value={value}
            registration={registration}
            isSelected={selectedTechnologies.includes(value)}
            icon={icon}
          >
            <span>{label}</span>
          </InterestRadioButton>
        ))}
        <Input
          placeholder="Other:"
          maxLength={OTHER_TECH_MAX}
          value={otherValue ?? ''}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onOtherChange(e.target.value)}
          className="text-base-primary w-full rounded-lg border px-4 py-2 text-sm font-medium transition-all focus:ring-2 focus:ring-offset-2 md:w-auto md:min-w-[200px] md:text-base h-auto"
          style={{
            borderColor: '#279D59',
            backgroundColor: 'white',
          }}
        />
        <Typography as="p" size="body-3" color="secondary" className="mt-1">
          {otherLength}/{OTHER_TECH_MAX}
        </Typography>
      </div>
    </div>
  );
}
